<template>
  <div class="digital-article-edit" :style="{ width: width + 'px' }">
    <div class="box">
      <div class="caption">文章编辑</div>
      <div class="title">
        <div class="label">文章标题</div>
        <div class="form">
          <el-input size="mini" :disabled="editorDisabled" v-model="articleTitle"></el-input>
        </div>
      </div>
      <div class="textarea">
        <DigitalRichText ref="digitalRichText" :editor-disabled="editorDisabled" v-model="articleText"></DigitalRichText>
      </div>
    </div>
  </div>
</template>
<script>
import DigitalRichText from './DigitalRichText'
export default {
  name: 'DigitalArticleEdit',
  components: {
    DigitalRichText
  },
  props: {
    width: {
      type: [Number, String],
      default: 400
    },
    editorDisabled: {
      type: Boolean,
      default: false
    },
    initArticleTitle: {
      type: String,
      default: ''
    },
    initArticleText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      articleTitle: this.initArticleTitle,
      articleText: this.initArticleText
    }
  },
  watch: {
    initArticleTitle(articleTitle) {
      this.articleTitle = articleTitle
    },
    initArticleText(articleText) {
      this.articleText = articleText
    },
    articleTitle(articleTitle) {
      this.$emit('onChange', articleTitle, this.articleText)
    },
    articleText(articleText) {
      this.$emit('onChange', this.articleTitle, articleText)
    }
  },
  mounted() {},
  methods: {
    getFileAttachArray(fileAttachIds) {
      return this.$refs.digitalRichText.getFileAttachArray(fileAttachIds)
    }
  }
}
</script>
<style lang="scss">
.digital-article-edit {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  background: #f3f3f3;
  z-index: 98;
  .box {
    height: 100%;
    padding: 24px;
    font-size: 14px;
    .caption {
      font-size: 16px;
      font-weight: bold;
    }
    .title {
      position: relative;
      margin: 15px 0;
      .label {
        position: absolute;
        top: 0;
        left: 0;
        line-height: 28px;
        z-index: 1;
      }
      .form {
        margin-left: 70px;
        .el-select {
          width: 100%;
        }
      }
    }
    .textarea {
      margin: 15px 0;
      height: calc(100% - 70px);
    }
  }
}
</style>
